const funcion12 = {
    titulo: `Función: parámetros predeterminados`,
    problemas: [
      {
        codigo: 1,
        descripcion: `Los valores por defecto en los parámetros permiten asignar de manera predeterminada datos, que se asignan a los parámetros de la función, en caso que no se indique ningún valor en su llamada.`,
        programa: `function sumar(v1, v2, v3 = 0) {
  return v1 + v2 + v3
}
    
console.log(sumar(1, 2))`,
        solucion: "3"
      }, {
        codigo: 2,
        descripcion: `En el ejemplo anterior v3 toma el valor 0 ya que no se le pasa un valor cuando invocamos la función console.log(sumar(1, 2))
En el caso que se le pase un valor, el valor que se le pasa se asigna a v3.`,
        programa: `function sumar(v1, v2, v3 = 0) {
  return v1 + v2 + v3
}
    
console.log(sumar(1, 2, 3))`,
        solucion: "6"
      }, {
        codigo: 3,
        descripcion: ``,
        programa: `function tablaMultiplicar(numero, terminos = 10) {
  const tabla = []
  for (let i = 1; i <= terminos; i++) {
    tabla.push(numero * i)
  }
  return tabla
}
    
const tabla = tablaMultiplicar(5, 3)
console.log(tabla)`,
        solucion: "[5, 10, 15]"
      }, {
        codigo: 4,
        descripcion: `Los parámetros predeterminados deben ser los últimos. Sino podemos obtener resultados inesperados.`,
        programa: `function potencia(base, exponente = 2) {
  return base ** exponente
}
    
console.log(potencia(5))`,
        solucion: "25"
      }, {
        codigo: 5,
        descripcion: `El resultado que nos genera este otro algoritmo no va a ser el esperado:`,
        programa: `function potencia( exponente = 2, base) {
  return base ** exponente
}
    
console.log(potencia(5))`,
        solucion: "NaN"
      }
    ]
  }
  
  export default funcion12;